module.exports = __webpack_public_path__ + "img/21(30).5791e1b1.png";